import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChatIcon from "@mui/icons-material/Chat";
import { Box, Button, Stack, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import CustomLoader from "../../../global/components/CustomLoader/CustomLoader";
import urls from "../../../global/constants/UrlConstants";
import { handleErrorMessage } from "../../../helpers/methods";
import {
  selectChatUsers,
  selectSelectedUser,
  selectUserEmail,
  setChatUsersAction,
} from "../../../redux/authSlice";
import history from "../../../utils/history";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { theme } from "../../../utils/styles";
import CompatibilityPercentage from "../../Shared/Compatibility/CompatibilityPercentage";
import TwoUsersDetails from "../../Shared/Compatibility/TwoUsersDetails";
import vedazTalkStyles from "../VedazTalk.styles";
import { compatibilityForUsers } from "../VedazTalkService";

const VedazCompatibility = () => {
  const classes = vedazTalkStyles;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useAppDispatch();
  const existingChatUser = useAppSelector(selectChatUsers);
  const user = useAppSelector(selectSelectedUser) || {};
  const loginUser = useAppSelector(selectUserEmail);
  const [compatibilityData, setCompatibilityData] = useState<any>(null);
  const [compatibilityPercentageData, setCompatibilityPercentageData] =
    useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user?.username) {
      getCompatibilityForUsers();
    }
  }, [user]);

  const getCompatibilityForUsers = async () => {
    try {
      setIsLoading(true);
      const response = await compatibilityForUsers(loginUser, user.username);
      setCompatibilityData(response);
      setCompatibilityPercentageData({
        destiny: response.destiny,
        emotional: response.emotional,
        marriage: response.marriage,
        physical: response.physical,
        soul: response.soul,
        totalPercentage: response.totalPercentage,
      });
    } catch (error) {
      handleErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChatSelection = () => {
    const isExistingChat = existingChatUser.some(
      (chatUser: any) => chatUser.username === user.username
    );
    if (!isExistingChat) {
      const updatedChatUsers: any = [user, ...existingChatUser];
      dispatch(setChatUsersAction({ chatUsers: updatedChatUsers }));
    }
    // dispatch(setSelectedUserAction({ selectedUser: user }));
    history.push(urls.vedazChatViewPath);
  };

  const getHeader = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { sm: "center", xs: "baseline" },
          width: "100%",
        }}
        pb={3}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          sx={{ cursor: "pointer", width: "fit-content" }}
          onClick={() => history.goBack()}
        >
          {isMobile ? (
            <ArrowBackIcon sx={{ color: "#ffffff", fontSize: "30px" }} />
          ) : (
            <ArrowBackIcon sx={{ color: "#ffffff", fontSize: "40px" }} />
          )}
        </Box>
        <Typography sx={classes.italicTypo}>{t("compatibility")}</Typography>
      </Box>
    );
  };

  const getStartConversation = () => {
    return (
      <Stack direction={"row"} justifyContent={"center"} mb={3}>
        <Button
          onClick={handleChatSelection}
          startIcon={<ChatIcon />}
          sx={classes.preferenceBtn}
        >
          <Typography sx={classes.preferenceBtnText}>
            {t("startConversationBtnText")}
          </Typography>
        </Button>
      </Stack>
    );
  };

  const getVedazCompatibility = () => {
    return (
      <>
        <Box sx={classes.mainContainer}>
          <Box sx={classes.mainBox}>
            <Box sx={classes.subBox}>
              <Box sx={classes.containerScrollStyle}>
                {getHeader()}
                {compatibilityData && (
                  <TwoUsersDetails
                    targetDetails={compatibilityData?.targetDetails}
                    userDetails={compatibilityData?.userDetails}
                  />
                )}
                {getStartConversation()}
                {compatibilityPercentageData && (
                  <CompatibilityPercentage
                    percentageData={compatibilityPercentageData}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <CustomLoader isLoading={isLoading} />
      </>
    );
  };

  return getVedazCompatibility();
};

export default VedazCompatibility;
